<!-- Modal modele info -->
<p-sidebar [visible]="showDialog" position="bottom" [modal]="false" [style]="{ width: '100%' }" (onHide)="onCancel()" (onShow)="onDialogShow()" class="mobile-modele-modal">
    <ng-template pTemplate="header">
        <div class="title-modal">
            <span class="font-bold" *ngIf="modelSelected">
                {{ 'HEADBAND.MODELE.MODAL.TITLE' | translate }} {{ modelSelected.libelle }}
            </span>
            <span>{{ ipsData.alt_Identifier ? '(' + ipsData.alt_Identifier + ')' : '' }}</span>
        </div>
    </ng-template>
    <div class="partenaire" *ngIf="partenaireTitle && partenaireImage">
        <img class="img-partenaire" src={{partenaireImage}} alt="Logo partenaire" style="width: 100%; max-width: 150px;">
        <span class="title-partenaire">{{partenaireTitle}}</span>
    </div>
    <div class="modal-container">
        <app-map-sensors-mobile [ipsData]="ipsData"></app-map-sensors-mobile>
        <app-graph-realtime-mobile [modelData]="modelRealTimeResult" [identifier]="ipsData.identifier"></app-graph-realtime-mobile>
        <hr>
        <app-graph-forecast-mobile 
        [modelDataForecast]="modelForecastResult" 
        [modelDataForecastLastest]="modelLastestForecastResult" 
        [modelDataObservation]="modelRealTimeResult"
        [modelSeuils]="modelSeuils"
        [identifier]="ipsData.identifier"
        [ipsPeriodesRetour]="ipsData.periodesRetour"></app-graph-forecast-mobile>
    </div>
</p-sidebar>